import React from "react";
import { useSelector } from "react-redux";

import BNLogoDark from "../../assets/bitcoin-navigator/BN-no-fill-dark.png";
import BNLogo from "../../assets/bitcoin-navigator/BN-no-fill.png";

const SIZES = {
  lg: 48,
  sm: 20,
};

const BitcoinNavigatorWordmark = ({ size = "lg" }) => {
  const themeMode = useSelector((state) => state.themeMode.themeMode);
  return (
    <img
      src={themeMode === "dark" ? BNLogoDark : BNLogo}
      alt="Bitcoin Navigator"
      style={{
        height: SIZES[size] || SIZES.lg,
        width: "auto",
        display: "block",
      }}
    />
  );
};

export default BitcoinNavigatorWordmark;
